import React, { useState, useEffect } from 'react';
import Draft from './PosterStates/Draft';
import ChannelEditorApprovalDeferred from './PosterStates/ChannelEditorApprovalDeferred';
import ChannelEditorApproval from './PosterStates/ChannelEditorApproval';
import Published from './PosterStates/Published';
import DeskRejected from './PosterStates/DeskRejected';
import Abandoned from './PosterStates/Abandoned';
import All from './PosterStates/All';

const Posters = ({postersPath, setSpinning, isParent}) => {

  const [data, setData] = useState(null);

  useEffect(() => {
    fetchData()
  }, [])

  const fetchData = () => {
    setSpinning(true)
    $.ajax({
      type: 'GET',
      url: postersPath,
      success: function(data) {
        setData(data)
        setSpinning(false)
        $(document).foundation('reflow');
      }
    });
  }

  const renderChevronContainer = (expanded, setExpanded, className='') => {
    return (
        <img 
          src="https://public.cureus.com/channel-icons/chevron-thin-down.png" 
          onClick={() => setExpanded(!expanded)} 
          onMouseOver={e => (e.currentTarget.src = "https://public.cureus.com/channel-icons/chevron-hovered-down.png")}
          onMouseOut={e => (e.currentTarget.src = "https://public.cureus.com/channel-icons/chevron-thin-down.png")}
          onMouseDown={e => (e.currentTarget.src = "https://public.cureus.com/channel-icons/chevron-clicked-down.png")}
          onMouseUp={e => (e.currentTarget.src = "https://public.cureus.com/channel-icons/chevron-hovered-down.png")}
          className={`chevron-toggle ${className} ${expanded ? "rotate" : ""}`}
        />
    )
  }

  const tooltip = (color) => {
    if(!color || color === 'grey') {
      return "Number of the articles in this state."
    } else if(color === 'orange') {
      return "Please, pay attention."
    } else {
      return "Your action is required to proceed further."
    }
  }

  if (!data) {
    return <div/>
  } else {
    return (
      <React.Fragment>
        <h5 className="articles-header">Posters <span>({data.total})</span></h5>
        <div className="articles-container">
          <Draft renderChevronContainer={renderChevronContainer} postersPath={postersPath} initialData={data.initial_data.draft} isParent={isParent} tooltip={tooltip(data.initial_data.draft.color)} />
          <ChannelEditorApproval renderChevronContainer={renderChevronContainer} postersPath={postersPath} initialData={data.initial_data.channel_editor_approval} isParent={isParent} tooltip={tooltip(data.initial_data.channel_editor_approval.color)} />
          <ChannelEditorApprovalDeferred renderChevronContainer={renderChevronContainer} postersPath={postersPath} initialData={data.initial_data.channel_editor_approval_deferred} isParent={isParent} tooltip={tooltip(data.initial_data.channel_editor_approval_deferred.color)} />
          <Published renderChevronContainer={renderChevronContainer} postersPath={postersPath} initialData={data.initial_data.published} isParent={isParent} tooltip={tooltip(data.initial_data.published.color)} />
          <DeskRejected renderChevronContainer={renderChevronContainer} postersPath={postersPath} initialData={data.initial_data.desk_rejected} isParent={isParent} tooltip={tooltip(data.initial_data.desk_rejected.color)} />
          <Abandoned renderChevronContainer={renderChevronContainer} postersPath={postersPath} initialData={data.initial_data.abandoned} isParent={isParent} tooltip={tooltip(data.initial_data.abandoned.color)} />
          <All renderChevronContainer={renderChevronContainer} postersPath={postersPath} initialData={data.initial_data.all} isParent={isParent} tooltip={tooltip(data.initial_data.all.color)} />
        </div>
      </React.Fragment>

    )
  }
}

export default Posters;